const DATA = [
    {
        id : 0,
        title : "Nike Mercurial Vapor 13",
        price : 59.99,
        desc : "Nike Jr. Mercurial Vapor 13 Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Jr_Mercurial_Vapor_13.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Jr_Mercurial_Vapor_13.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Jr_Mercurial_Vapor_13.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Jr_Mercurial_Vapor_13.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Jr_Mercurial_Vapor_13.jpeg",
        size1:39,
        size2:40
    },
    {
        id : 1,
        title : "Nike Neymar Vapor 12",
        price : 84.99,
        desc : "Nike Neymar Vapor 12 Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Neymar_Vapor_12.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Neymar_Vapor_12.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Neymar_Vapor_12.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Neymar_Vapor_12.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Neymar_Vapor_12.jpeg",
        size1:38,
        size2:39
    },
    {
        id : 2,
        title : "Nike Vapor 12 Pro",
        price : 119.99,
        desc : "Nike Vapor 12 Pro Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Vapor_12_Pro.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Vapor_12_Pro.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Vapor_12_Pro.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Vapor_12_Pro.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Vapor_12_Pro.jpeg",
        size1:39,
        size2:43
    },
    {
        id : 3,
        title : "Nike Vapor 12 Elite",
        price : 249.99,
        desc : "Nike Vapor 12 Elite Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Vapor_12_Elite.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Vapor_12_Elite.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Vapor_12_Elite.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Vapor_12_Elite.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Vapor_12_Elite.jpeg",
        size1:38,
        size2:42
    },
    {
        id : 4,
        title : "Nike Mercurial Victory VI Dynamic Fit",
        price : 89.99,
        desc : "Nike Mercurial Victory VI Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Mercurial_Victory_VI.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Mercurial_Victory_VI.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Mercurial_Victory_VI.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Mercurial_Victory_VI.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Mercurial_Victory_VI.jpeg",
        size1:39,
        size2:40
    },
    {
        id : 5,
        title : "Nike CR7 Superfly 6 MG Multi-Ground",
        price : 94.99,
        desc : "Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_CR7_Superfly_6.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_CR7_Superfly_6.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_CR7_Superfly_6.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_CR7_Superfly_6.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_CR7_Superfly_6.jpeg",
        size1:39,
        size2:40
    },
    {
        id : 6,
        title : "Nike Mercurial Vapor 13 Elite Tech",
        price : 249.99,
        desc : "Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Mercurial_Vapor_13.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Mercurial_Vapor_13.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Mercurial_Vapor_13.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Mercurial_Vapor_13.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Mercurial_Vapor_13.jpeg",
        size1:40,
        size2:42
    },
    {
        id : 7,
        title : "Nike Mercurial Superfly 7 Elite",
        price : 274.99,
        desc : "Nike Mercurial Superfly 7 Elite Firm-Ground Football Boot",
        img : "/assets/images/products/Nike/Nike_Mercurial_Superfly_7_Elite.jpeg",
        img2 : "/assets/images/products/Nike/img2/Nike_Mercurial_Superfly_7_Elite.jpeg",
        img3 : "/assets/images/products/Nike/img3/Nike_Mercurial_Superfly_7_Elite.jpeg",
        img4 : "/assets/images/products/Nike/img4/Nike_Mercurial_Superfly_7_Elite.jpeg",
        img5 : "/assets/images/products/Nike/img5/Nike_Mercurial_Superfly_7_Elite.jpeg",
        size1:40,
        size2:41
    },
    {
        id : 8,
        title : "Adidas X Speedflow",
        price : 74.99,
        desc : "Nike Mercurial Superfly 7 Elite Firm-Ground Football Boot",
        img : "/assets/images/products/Adidas/1.png",
        img2 : "/assets/images/products/Adidas/img2/1.png",
        img3 : "/assets/images/products/Adidas/img3/1.png",
        img4 : "/assets/images/products/Adidas/img4/1.png",
        img5 : "/assets/images/products/Adidas/img5/1.png",
        size1:39,
        size2:40
    },
    {
        id : 9,
        title : "Adidas Predator Freak",
        price : 94.99,
        desc : "Adidas X Speedflow Firm-Ground Football Boot",
        img : "/assets/images/products/Adidas/2.png",
        img2 : "/assets/images/products/Adidas/img2/2.png",
        img3 : "/assets/images/products/Adidas/img3/2.png",
        img4 : "/assets/images/products/Adidas/img4/2.png",
        img5 : "/assets/images/products/Adidas/img5/2.png",
        size1:41,
        size2:42
    },
    {
        id : 10,
        title : "Adidas Edge of Darkness",
        price : 119.99,
        desc : "Adidas X Speedflow - Edge of Darkness Pack, Firm-Ground Football Boot",
        img : "/assets/images/products/Adidas/3.png",
        img2 : "/assets/images/products/Adidas/img2/3.png",
        img3 : "/assets/images/products/Adidas/img3/3.png",
        img4 : "/assets/images/products/Adidas/img4/3.png",
        img5 : "/assets/images/products/Adidas/img5/3.png",
        size1:39,
        size2:43
    },
    {
        id : 11,
        title : "Adidas Copa Sense",
        price : 174.99,
        desc : "Adidas Copa Sense Firm-Ground Football Boot",
        img : "/assets/images/products/Adidas/4.png",
        img2 : "/assets/images/products/Adidas/img2/4.png",
        img3 : "/assets/images/products/Adidas/img3/4.png",
        img4 : "/assets/images/products/Adidas/img4/4.png",
        img5 : "/assets/images/products/Adidas/img5/4.png",
        size1:38,
        size2:39
    },
]
export default DATA;